import React from 'react';
import './App.css';
import Dimensional from './Dimensional/Dimensional';

function App() {
  return (
    <div>
      <Dimensional />
    </div>
  );
}

export default App;